export interface ITemplateData {
  deviceType: string;
  nodeNumber: number;
  deviceIp: string;
  model: string[];
}

export interface IDeviceTemplateForm {
  name: string;
  numberOfNodes: number;
  templateData: ITemplateData[];
}

export const defaultDeviceTemplateForm: IDeviceTemplateForm = {
  name: "",
  numberOfNodes: 0,
  templateData: [],
};

export const deviceTemplateRules = {
  name: {
    required: true,
  },
  numberOfNodes: {
    required: true,
    pattern: /^[1-9]\d*$/,
  },
  templateData: {
    deviceType: {
      required: true,
    },
    nodeNumber: {
      required: true,
    },
    deviceIp: {
      required: true,
      pattern: /^\d{1,3}(\.\d{1,3}){3}$/,
    },
    model: {
      required: true,
    },
  },
};

export const modelLabelMap: Record<string, string> = {
  gasleak: "Leak",
  liquidleak: "Liquid Leak",
  firesmoke: "Fire/Smoke",
  hardhat: "Hard Hat",
  agg: "Gate Guard",
  tlm: "Tank Level",
};
